import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  MainContainer, TabsContainer, BreadCrumbContainer, MenuContainer,
  UserColumnContainer, SideColumn, MainColumn, CustomSearchInput, InputField,
  SearchIcon, CustomGrid, StyledIconButton
} from "./RoleGeneral.styled";
import RoleDetails from "../RoleDetails/RoleDetails";
import { RoundedButton, Icon } from '../../../../../elements';
import Tabs from '../../../../../elements/v2/Tabs/Tabs';
import RolePermissions from "../RolePermissions/RolePermissions";
import SuccessModal from '../../../../../elements/v2/SuccessModal/SuccessModal';
import { useStore } from '../../../../../hooks';
import ConfirmationWrapper from "../../../AgentsTeam/Team/Components/ConfirmationWrapper/ConfirmationWrapper";
import AddMemberModal from "../AddMembersModal/AddMemberModal";
import { ModalFilter } from "../../../AsistantManagement/components";
import { useLocation } from "react-router-dom";
import DynamicBreadcrumbs from "../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";

const RoleGeneral = () => {
  const { roleId } = useParams();
  const { listRoleStore, authStore, permissionsSetupStore } = useStore();
  const [selectedTab, setSelectedTab] = useState(0);
  const [setRoleDetails] = useState(null);
  const [originalRoleDetails] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [successModalContent, setSuccessModalContent] = useState({ isOpen: false, title: '', message: '' });
  const [actionConfig, setActionConfig] = useState(null);
  const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  
  const discardHandlerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    listRoleStore.setCustomer(authStore.selectedAccount.id)
    listRoleStore.fetchRoleData(roleId)
    listRoleStore.fetchPermissionsCatalogUser()
    listRoleStore.fetchRolePermissions(roleId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleId]); 

  const handleSave = () => {
    openConfirmationModal({
      name: 'Save Changes',
      title: 'Save Changes',
      message: 'Are you sure you want to save the changes?',
      icon: 'info',
      onConfirm: confirmSave,
    });
  };

  const confirmSave = async () => {
    try {
      if(selectedTab === 0){
        const {name, description, id} = listRoleStore.selectedRole
        await listRoleStore.createRole(name, description, id);
      } else if(selectedTab === 1){
        await listRoleStore.saveAccess(permissionsSetupStore.generateSaveStructure())
      }

      setSuccessModalContent({
        isOpen: true,
        title: 'Success',
        message: 'Changes have been saved successfully!',
      });
    } catch (error) {
      listRoleStore.setError("Error saving role");
      setSuccessModalContent({
        isOpen: true,
        title: 'Error',
        message: 'An error occurred while saving.',
      });
    } finally {
      setIsModalOpen(false);
      setTimeout(() => {
        setSuccessModalContent((prev) => ({
          ...prev,
          isOpen: false,
        }));
      }, 5000);
    }
  };

  const handleDiscard = () => {
    setRoleDetails({ ...originalRoleDetails });
    if (discardHandlerRef.current) {
      discardHandlerRef.current();
    }
  };  

  const openConfirmationModal = (config) => {
    setActionConfig(config);
    setIsModalOpen(true);
  };

  const tabs = [
    {
      label: 'General',
      content: (
        <RoleDetails/>
      ),
    },
    {
      label: 'Access',
      content: (
        <RolePermissions />
      ),
    },
  ];

  const handleCloseAddMemberModal = () => {
    setIsAddMemberModalOpen(false);
  };

  const breadcrumbItems = [
    { label: "Roles", href: "/v2/roles" },
    { label: listRoleStore.selectedRole.name }    
  ];
  

  return (
    <>
      <MainContainer>
        <BreadCrumbContainer>
          <DynamicBreadcrumbs items={breadcrumbItems} currentPath={location.pathname} />
        </BreadCrumbContainer>
        <MenuContainer>
          <RoundedButton width='60px' height='30px' fontSize='12px' outline={true} onClick={handleDiscard}>
            Discard
          </RoundedButton>
          <RoundedButton width='80px' height='30px' fontSize='12px' color='#2173FF' onClick={handleSave}>
            Save
          </RoundedButton>
        </MenuContainer>
      </MainContainer>

      {selectedTab === 2 && (
        <CustomGrid>
          <div>
            <CustomSearchInput width='50px'>
              <InputField
                type="text"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search"
              />
              <SearchIcon>
                <Icon name={"magnifier"} height={'20px'} width={'20px'} />
              </SearchIcon>
            </CustomSearchInput>
          </div>
          <div>
            <StyledIconButton aria-controls="custom-dropdown" aria-haspopup="true" >
              <Icon name={"tuneIcon"} height={'15px'} width={'15px'} />
            </StyledIconButton>

            <ModalFilter

              title="Filter"
              modalWidth="250"
            />
          </div>
        </CustomGrid>
      )}

      <UserColumnContainer>
        <MainColumn>
          <TabsContainer>
            <Tabs
              tabs={tabs}
              externalActiveTab={selectedTab}
              onToggleTab={setSelectedTab}
              showBorder={true}
            />
          </TabsContainer>
        </MainColumn>
        <SideColumn>
        </SideColumn>
      </UserColumnContainer>

      {isAddMemberModalOpen && (
        <AddMemberModal
          onAddGroups={(selectedGroups) => {
            setIsAddMemberModalOpen(false);
          }}
          onClose={handleCloseAddMemberModal}
        />
      )}

      <ConfirmationWrapper
        isOpen={isModalOpen}
        actionConfig={actionConfig}
        onConfirm={actionConfig?.onConfirm}
        onClose={() => setIsModalOpen(false)}
      />

      <SuccessModal
        isOpen={successModalContent.isOpen}
        icon="check_circle"
        onClose={() => setSuccessModalContent({ ...successModalContent, isOpen: false })}
        title={successModalContent.title}
        message={successModalContent.message}
      />
    </>
  );
};

export default RoleGeneral;
